"use client";

import { usePortalTranslations } from "../i18n/client";
import styles from "./PortalContactDetails.module.css";

type ContactKind = "address" | "email" | "phone";

function ContactIcon({ kind }: { kind: ContactKind }) {
  return <svg className={styles.icon} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    {kind === "address" ? <><path d="M20 10c0 6-8 11-8 11S4 16 4 10a8 8 0 1 1 16 0Z" /><circle cx="12" cy="10" r="2.5" /></> : null}
    {kind === "email" ? <><rect x="3" y="5" width="18" height="14" rx="3" /><path d="m3 7 9 6 9-6" /></> : null}
    {kind === "phone" ? <path d="M21 16.4v3a2 2 0 0 1-2.2 2 19.7 19.7 0 0 1-8.6-3.1 19.4 19.4 0 0 1-6-6A19.7 19.7 0 0 1 1.1 3.6 2 2 0 0 1 3.1 1.4h3a2 2 0 0 1 2 1.7c.1 1 .4 2 .7 2.9a2 2 0 0 1-.5 2.1L7 9.4a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.5c.9.3 1.9.6 2.9.7a2 2 0 0 1 1.7 2.1Z" /> : null}
  </svg>;
}

export function PortalContactDetails({ address, email, phone }: { address?: string | null; email?: string | null; phone?: string | null }) {
  const t = usePortalTranslations();
  const contacts: { kind: ContactKind; value: string; href?: string }[] = [
    { kind: "address", value: address?.trim() ?? "" },
    { kind: "email", value: email?.trim() ?? "", href: `mailto:${email?.trim() ?? ""}` },
    { kind: "phone", value: phone?.trim() ?? "", href: `tel:${phone?.replace(/[^+0-9]/g, "") ?? ""}` },
  ];
  const visibleContacts = contacts.filter(({ value }) => value);

  if (!visibleContacts.length) return null;

  return <address className={styles.details}>
    {visibleContacts.map(({ kind, value, href }) => {
      const content = <>
        <ContactIcon kind={kind} />
        <span className={styles.copy}>
          <span className={styles.label}>{t(`portal.home.contact.${kind}`)}</span>
          <span className={styles.value}>{value}</span>
        </span>
      </>;
      return href ? <a key={kind} className={styles.item} href={href}>{content}</a> : <div key={kind} className={styles.item}>{content}</div>;
    })}
  </address>;
}
